import PropTypes from 'prop-types';
import { cloneElement, useState, useEffect } from 'react';
import { Portal } from 'react-portal';
import { useTransition, animated } from 'react-spring';

import Iframe from './Iframe';

const SidePreview = ({
  openByClickOn,
  isPortalOpened = false,
  onClose,
  onOpen,
  url,
  headerVisible = true,
}) => {
  const [isOpen, setIsOpen] = useState(isPortalOpened);

  useEffect(() => {
    setIsOpen(isPortalOpened);

    if (isPortalOpened && onOpen) {
      onOpen();
    }
  }, [isPortalOpened, onOpen]);

  const transitions = useTransition(isOpen, {
    from: { opacity: 0, x: 100, pointerEvents: 'none' },
    enter: { opacity: 1, x: 0, pointerEvents: 'auto' },
    leave: { opacity: 0, x: 100, pointerEvents: 'none' },
  });
  const handleOpen = () => {
    setIsOpen(true);

    if (onOpen) {
      onOpen();
    }
  };
  const handleClose = () => {
    setIsOpen(false);

    if (onClose) {
      onClose();
    }
  };

  return (
    <>
      {openByClickOn &&
        cloneElement(openByClickOn, {
          onClick: handleOpen,
        })}
      <Portal>
        {transitions(
          (styles, item) =>
            item && (
              <>
                <animated.div
                  style={{
                    opacity: styles.opacity,
                    transform: styles.x.to((x) => `translate3d(${x}%, 0, 0)`),
                  }}
                  className="side-preview__floating-entry-content side-preview__slider-container"
                >
                  <div>
                    <div className="side-preview__close-button">
                      <i className="icon-multiply" onClick={handleClose} />
                    </div>
                    {headerVisible && (
                      <div className="side-preview__header side-preview__slider-container">
                        <div className="side-preview__header-close-button" />
                      </div>
                    )}
                    <div
                      className="side-preview__entry-scroller"
                      style={{ top: !headerVisible && 0 }}
                    >
                      {isOpen && <Iframe src={url} height="99%" width="100%" />}
                    </div>
                  </div>
                </animated.div>
                <animated.div
                  style={{
                    opacity: styles.opacity,
                    pointerEvents: styles.pointerEvents,
                  }}
                  className="side-preview__entry-overlay"
                  onClick={handleClose}
                />
              </>
            ),
        )}
      </Portal>
    </>
  );
};

SidePreview.propTypes = {
  url: PropTypes.string.isRequired,
  openByClickOn: PropTypes.element,
  isPortalOpened: PropTypes.bool,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  headerVisible: PropTypes.bool,
};

export default SidePreview;
